import { extend } from './utils';
import base from './base';

export default extend(base, {
  backgroundPrimary: '#1f2022',
  backgroundSecondary: '#2d2d31',
  backgroundHover: '#3b3b3e',
  textPrimary: '#dee2e6',
  textSecondary: '#FFD479',
  blockquoteBackground: '#2a4661',
  highlight: 'hsl(50, 80%, 35%)',
});